import React from "react";
import './footer.css'

export function FooterComponent() {
    return (
        <footer role="foo" className="footer">
            <p>Copyright &copy; 2024 ShesAMobileDev All Rights Reserved. I do not speak for any company or person.</p>
        </footer>
    )
}
